import { StyledContent, StyledTitle } from '@/components/styles'
import addSoftHyphenation from '@/lib/addSoftHyphenation'
import generateBlocks from '@/lib/generateBlocks'
import { AnchoredContent, ContentParentLink } from '@/components'
import { useTranslation } from "react-i18next";

export default function WikiArticlePage(props) {
  const { title, blocks } = props
  const { t } = useTranslation("global");

  return (
    <StyledContent withLine>
      <StyledContent.Container>
        <StyledContent.Columns>
          <ContentParentLink type="wiki">{t('wiki.title')}</ContentParentLink>

          <AnchoredContent
            navHeader={
              <StyledTitle mb="medium" as="h1">
                {addSoftHyphenation(title, 15)}
              </StyledTitle>
            }
          >
            {blocks && blocks.length > 0 && generateBlocks(blocks)}
          </AnchoredContent>
        </StyledContent.Columns>
      </StyledContent.Container>
    </StyledContent>
  )
}
